import { useEffect, useState } from 'react';

// Wrapper around localStorage for persisting quiz progress.
// Returns the whole progress object and a setter.

const STORAGE_KEY = 'concurso-study-progress-v1';

export function useProgress() {
  const [progress, setProgress] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
    } catch {
      // ignore quota exceeded etc.
    }
  }, [progress]);

  return progress;
}

export function saveModuleResult(moduleId, scorePercent) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const obj = raw ? JSON.parse(raw) : {};
    obj[moduleId] = { done: true, score: scorePercent, ...obj[moduleId] };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch {
    // ignore
  }
}

export function saveModuleProgress(moduleId, progressData) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const obj = raw ? JSON.parse(raw) : {};
    obj[moduleId] = { ...obj[moduleId], ...progressData };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch {
    // ignore
  }
}
